import http from "../../../utils/HttpUtils";

//货位接口服务
class PositionService {
    //新建货位
    static async insert(data) {
        const apiUrl = "/base/warehouse/position/insert";
        return await http.post(apiUrl, data);
    }
    //批量新增货位
    static async batchInsertShelfs(data) {
        const apiUrl = "/base/warehouse/position/batchInsertShelfs";
        return await http.post(apiUrl, data);
    }
    //修改货位
    static async update(data) {
        const apiUrl = "/base/warehouse/position/update";
        return await http.post(apiUrl, data);
    }

    //根据ID查询货位信息
    static async findOne(id) {
        const apiUrl = `/whShelf/find/${id}`;
        return await http.get(apiUrl);
    }

    //分页查询货位信息
    static async findPage(data) {
        const apiUrl = "/base/warehouse/position/findPage";
        return await http.post(apiUrl, data);
    }

    //根据ID删除货位信息
    static async deleteOne(id) {
        const apiUrl = `/whShelf/deleteOne/${id}`;
        return await http.post(apiUrl);
    }
}

export default PositionService;
